import React, { FC, memo } from 'react'

import { LoginHeader } from '@/components/LoginHeader'
import { DescriptionQr } from '@/components/QrCode/DescriptionQr'
import { QrCode } from '@/components/QrCode/QrCode'
import { titleData } from '@/constants/login'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'
import { CheckoutSessionProps } from '@/types/componentsPropsTypes'

import { SessionContainer } from './styles'
import { QrContainer, QrWrapperMobileBg } from '../styles'

const CheckoutSessionRow: FC<CheckoutSessionProps> = ({
  code,
  qrUrl,
  qrCodeUrl,
  remainingTime,
}) => {
  const { t } = useCommonTranslation()

  return (
    <SessionContainer>
      <LoginHeader
        showLogo={false}
        title={t(titleData.created_checkout.title)}
        description={t(titleData.created_checkout.description)}
      />
      <QrContainer>
        <QrWrapperMobileBg>
          {qrCodeUrl && <QrCode qrPath={qrCodeUrl} />}
        </QrWrapperMobileBg>
        <DescriptionQr
          link={qrUrl}
          code={code}
          mobileStyle={true}
          remainingTime={remainingTime}
        />
      </QrContainer>
    </SessionContainer>
  )
}

export const CheckoutSession = memo(CheckoutSessionRow)
